module.exports = __webpack_public_path__ + "static/media/logo.579fca1d.png";